import type { LucideIcon } from "lucide-react";

import * as React from "react";

import {
  FieldContent,
  FieldDescription,
  FieldTitle,
} from "@replo/design-system/components/field/Field";
import twMerge from "@replo/design-system/utils/twMerge";
import { Calendar, Download, Package } from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  Package,
  Download,
  Calendar,
};

interface ProductTypeCardProps {
  name: string;
  description: string;
  icon: string;
  isSelected: boolean;
  onClick: () => void;
}

export function ProductTypeCard({
  name,
  description,
  icon,
  isSelected,
  onClick,
}: ProductTypeCardProps) {
  const Icon = iconMap[icon] ?? Package;

  const iconElement = (
    <div
      className={twMerge(
        "flex items-center justify-center size-8 rounded-md border-[0.5px] border-border transition-colors duration-200",
        isSelected ? "bg-white" : "bg-sheet group-hover:bg-white",
      )}
    >
      <Icon className="size-4.5 text-default" strokeWidth={1.5} />
    </div>
  );

  return (
    <button
      type="button"
      className={twMerge(
        "border-0.5 border-border text-muted flex w-full cursor-pointer break-words rounded-lg text-left font-normal hover:bg-selectable-hover",
        "group shadow-xs md:w-auto md:min-w-52 md:max-w-72",
        isSelected ? "!border-default !bg-sheet hover:!bg-sheet" : "bg-white",
      )}
      onClick={onClick}
    >
      <div className="flex flex-1 flex-col gap-2 p-4">
        {iconElement}
        <FieldContent>
          <FieldTitle>{name}</FieldTitle>
          <FieldDescription className="text-balance pt-1">
            {description}
          </FieldDescription>
        </FieldContent>
      </div>
    </button>
  );
}
